import { render, staticRenderFns } from "./CAHG1130.vue?vue&type=template&id=2b4b877c&scoped=true"
import script from "./CAHG1130Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAHG1130Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAHG1130.vue?vue&type=style&index=0&id=2b4b877c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b877c",
  null
  
)

export default component.exports